import React, { Component } from "react";
import { Link } from "react-router-dom";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import "../articles/articles.css";
import "./homePage.css";
const BoardItem = (props) => {
  const [open, setOpen] = React.useState();
  const onOpenModal = () => {
    setOpen(true);
  };

  const onCloseModal = () => {
    setOpen(false);
  };
  return (
    <div
      className={`BoardItem ${props.isTopManagement ? "isTopManagement" : ""}`}
    >
      <Modal open={open} onClose={onCloseModal} center>
        <div
          dangerouslySetInnerHTML={{
            __html:
              "<h2 class='BlogTitle'>" +
              props.board.title +
              "</h2>" +
              "<img class='BoardImage' src='" +
              props.board.image +
              "'/>" +
              "<p class='BlogText'>" +
              props.board.htmlcontent +
              "</p>",
          }}
        ></div>
      </Modal>
      <div className="BoardItemImageBox" onClick={onOpenModal}>
        <img
          className="BoardItemImage"
          src={props.board.image}
          alt=""
          style={{
            objectPosition: props.board.imagePos || "",
            transform: `${
              props.board.imageScale
                ? `scale(${props.board.imageScale})`
                : "none"
            }`,
          }}
        />
      </div>
      <div className="BoardItemTitle">
        {props.board.name}&nbsp;|&nbsp;{props.board.title}
      </div>
      <div className="BoardItemDesc">{props.board.desc}</div>
      <div className="BoardItemDate">{props.board.date}</div>
    </div>
  );
};

export default BoardItem;
